import React, { FunctionComponent, useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { InputOuter, HeadRadioContainer, HeadRadioLabel, RadioInput, InputContainer, InputLabel, TextInput, RadioContainer, RadioLabel, ZipCodeInput, TextArea, SubmitButton } from './form-components'

type ContactFormProps = {

}
export const ContactForm: FunctionComponent<ContactFormProps> = () => {
  const {executeRecaptcha} = useGoogleReCaptcha()
  const [type, setType] = useState('')
  const [childName, setChildName] = useState('')
  const [childNameKana, setChildNameKana] = useState('')
  const [childSex, setchildSex] = useState('')
  const [childBirthday, setchildBirthday] = useState('')
  const [parentName, setParentName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [address, setAddress] = useState('')
  const [lineId, setLineId] = useState('')
  const [message, setMessage] = useState('')

  const send = async () => {
    const formData = new FormData()
    formData.append('type', type)
    formData.append('child_name', childName)
    formData.append('child_name_kana', childNameKana)
    formData.append('child_sex', childSex)
    formData.append('child_birthday', childBirthday)
    formData.append('parent_name', parentName)
    formData.append('phone_number', phoneNumber)
    formData.append('zip_code', zipCode)
    formData.append('address', address)
    formData.append('line_id', lineId)
    formData.append('message', message)

    if(executeRecaptcha){
      const token = await executeRecaptcha('homepage')
      if(token){
        formData.append('_wpcf7_recaptcha_response', token)
      }
    }

    const res = await fetch('http://www.muronokids-ninteikodomoen.jp/wp/wp-json/contact-form-7/v1/contact-forms/1721/feedback', {
      method: 'POST',
      body: formData
    }).then(res => res.json())
    // @ts-ignore
    alert(res.message)
    if(res.status === 'mail_sent'){
      setType('')
      setChildName('')
      setChildNameKana('')
      setParentName('')
      setPhoneNumber('')
      setZipCode('')
      setAddress('')
      setLineId('')
      setMessage('')
    }
  }

  return <InputOuter>
    <HeadRadioContainer>
      <HeadRadioLabel>
        <RadioInput type="radio" name="type" value="プティ" onChange={e => e.currentTarget.checked ? setType('プティ') : null} />
        プティ
      </HeadRadioLabel>
      <HeadRadioLabel>
        <RadioInput type="radio" name="type" value="アプレプティ" onChange={e => e.currentTarget.checked ? setType('アプレプティ') : null} />
        アプレプティ
      </HeadRadioLabel>
      <HeadRadioLabel>
        <RadioInput type="radio" name="type" value="ムロノキッズBaby" onChange={e => e.currentTarget.checked ? setType('ムロノキッズBaby') : null} />
        ムロノキッズBaby
      </HeadRadioLabel>
      <HeadRadioLabel>
        <RadioInput type="radio" name="type" value="ムロノキッズ" onChange={e => e.currentTarget.checked ? setType('ムロノキッズ') : null} />
        ムロノキッズ
      </HeadRadioLabel>
    </HeadRadioContainer>
    <InputContainer required>
      <InputLabel>お子様の名前</InputLabel>
      <TextInput type="text" value={childName} onChange={e => setChildName(e.currentTarget.value)}/>
    </InputContainer>
    <InputContainer required>
      <InputLabel>フリガナ</InputLabel>
      <TextInput type="text" value={childNameKana} onChange={e => setChildNameKana(e.currentTarget.value)}/>
    </InputContainer>
    <InputContainer as="div" required>
      <InputLabel>お子様の性別</InputLabel>
      <RadioContainer>
        <RadioLabel>
          <RadioInput type="radio" name="sex" value="男" onChange={e => e.currentTarget.checked ? setchildSex('男') : null} />
          男
        </RadioLabel>
        <RadioLabel>
          <RadioInput type="radio" name="sex" value="女" onChange={e => e.currentTarget.checked ? setchildSex('女') : null} />
          女
        </RadioLabel>
      </RadioContainer>
    </InputContainer>
    <InputContainer required>
      <InputLabel>お子様の生年月日</InputLabel>
      <TextInput type="text" value={childBirthday} onChange={e => setchildBirthday(e.currentTarget.value)} placeholder="2018年1月30日"/>
    </InputContainer>
    <InputContainer required>
      <InputLabel>保護者氏名</InputLabel>
      <TextInput type="text" value={parentName} onChange={e => setParentName(e.currentTarget.value)}/>
    </InputContainer>
    <InputContainer required>
      <InputLabel>携帯電話番号</InputLabel>
      <TextInput type="text" value={phoneNumber} onChange={e => setPhoneNumber(e.currentTarget.value)}/>
    </InputContainer>
    <InputContainer required>
      <InputLabel>郵便番号</InputLabel>
      <ZipCodeInput type="text" value={zipCode} onChange={e => setZipCode(e.currentTarget.value)}/>
    </InputContainer>
    <InputContainer>
      <InputLabel>住所</InputLabel>
      <TextInput type="text" value={address} onChange={e => setAddress(e.currentTarget.value)}/>
    </InputContainer>
    <InputContainer>
      <InputLabel>備考</InputLabel>
      <TextArea value={message} onChange={e => setMessage(e.currentTarget.value)} />
    </InputContainer>
    <SubmitButton onClick={send}>送信</SubmitButton>
  </InputOuter>
}